import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { IconButtonComponent } from "@hermes/aphrodite/icon-button";
import {
    svgCross,
    SvgIconComponent,
    svgMinus,
    svgPlus,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import { ProductPageModule } from "@hermes/pages/product";
import { ProductImageSeoUrlPipeModule } from "@hermes/states/product-page";
import { ImageErrorDefaultDirective } from "@hermes/utils-generic/directives/image-error-default";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { I18nAssetAttributeDirectiveModule } from "@hermes/utils-generic/i18n-asset-attribute";

import { ImageZoomScaleSliderComponent } from "./components/image-zoom-scale-slider/image-zoom-scale-slider.component";
import { ImageZoomScaleSliderDeprecatedComponent } from "./components/image-zoom-scale-slider-deprecated/image-zoom-scale-slider-deprecated.component";
import { ProductImageZoomComponent } from "./components/product-image-zoom/product-image-zoom.component";
import { ProductImageZoomDeprecatedComponent } from "./components/product-image-zoom-deprecated/product-image-zoom-deprecated.component";
import { ProductImageZoomGalleryComponent } from "./components/product-image-zoom-gallery/product-image-zoom-gallery.component";
import { ProductImageZoomImageComponent } from "./components/product-image-zoom-image/product-image-zoom-image.component";
import { ProductImageZoomImageDeprecatedComponent } from "./components/product-image-zoom-image-deprecated/product-image-zoom-image-deprecated.component";
import { ProductImagePersoUrlPipeModule } from "./pipes/product-image-perso-url.pipe";
import { ZoomService } from "./services/zoom.service";

const COMPONENTS = [
    ProductImageZoomDeprecatedComponent,
    ProductImageZoomGalleryComponent,
    ProductImageZoomImageDeprecatedComponent,
    ImageZoomScaleSliderDeprecatedComponent,
    ImageZoomScaleSliderComponent,
    ProductImageZoomComponent,
    ProductImageZoomImageComponent,
];

@NgModule({
    declarations: [COMPONENTS],
    exports: [COMPONENTS],
    imports: [
        A11yModule,
        CommonModule,
        ProductImagePersoUrlPipeModule,
        ProductImageSeoUrlPipeModule,
        I18nAssetAttributeDirectiveModule,
        SrOnlyNoSnippetDirective,
        ImageErrorDefaultDirective,
        ProductPageModule,
        IconButtonComponent,
        SvgIconComponent,
    ],
    providers: [ZoomService],
})
export class ZoomModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgCross, svgPlus, svgMinus]);
    }
}
